import { gql } from '@apollo/client'

export const CURRENT_USER_FRAGMENT = gql`
  fragment CurrentUserFragment on CurrentUser {
    id
    email
    firstname
    lastname
    permissions {
      model
      action
    }
  }
`

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    displayName
    email
    firstname
    lastname
  }
`

export const CURRENT_USER_QUERY = gql`
  {
    currentUser {
      ...CurrentUserFragment
    }
  }
  ${CURRENT_USER_FRAGMENT}
`

export const INTERNAL_MANAGERS_QUERY = gql`
  {
    internalManagers {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`

export const LEGALISTS_QUERY = gql`
  {
    legalists {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`

export const ADDRESSES_QUERY = gql`
  {
    allAddresses {
      id
      shortname
    }
  }
`
